/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowRightUp: {
  name: 'arrow-right-up';
  data: string;
} = {
  name: 'arrow-right-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-2 0V9.414l-8.293 8.293a1 1 0 0 1-1.414-1.414L14.586 8H9a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
